import { IdMappedObject } from './ObjectDatastoreMapping';

class Area extends IdMappedObject {
	static collectionId = 'areas';
}

export default Area;